module.exports = __webpack_public_path__ + "static/masdie-75032dd00b5a3cf5735becdb558a7c03.png";